import React, { useState } from 'react';
import NavItem from '@plone/volto/components/theme/Navigation/NavItem';
import PropTypes from 'prop-types';
import { Dropdown } from 'semantic-ui-react';
import { useHistory , useLocation } from 'react-router-dom';
const NavItems = ({ items, lang , mobile = false, closeNavigation = null}) => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const history = useHistory();
  const location = useLocation();

  const handleDropdownClick = (item) => {
    history.push(item.url);
    setOpenDropdown(null);
    closeNavigation?.();
  };

  const handleDropdownToggle = (item, e) => {
    if (e.target.localName === "div" && e.target.classList.contains('divider')) {
      handleDropdownClick(item);
    } else {
      e.stopPropagation(); 
      setOpenDropdown(openDropdown === item.url ? null : item.url);
    }
  };

  var dropdownClassName = mobile ? "item" : "item simple";
  return (
    <>
      {items.map((item, index) => {
        // Calcola l'indice a metà della lista
        const halfIndex = Math.ceil(items.length / 2);
        
        // Determina la classe in base alla posizione rispetto a metà
        const transitionClass = index < halfIndex ? 'transition-right' : 'transition-left';
        const inPath = (location.pathname === item.url || location.pathname.includes(item.url));
        return (
          item && item.items && item.items.length > 0 ? (
            <Dropdown 
              text={item.title} 
              className={`${dropdownClassName}${inPath ? ' inPath' : ''}`}
              key={item.url} 
              closeOnChange={true}
              open={openDropdown === item.url}
              onClick={(e) =>
                mobile
                  ? handleDropdownToggle(item, e) // Solo per mobile
                  : handleDropdownClick(item) // Per desktop, naviga al link
              }>
              <Dropdown.Menu 
                key={item.url} 
                className={transitionClass}
              >
                {item.items.map((dropdownitem) => (
                  <a 
                    className="item" 
                    onClick={(e) => {
                      e.stopPropagation();
                      history.push(dropdownitem.url);
                      closeNavigation?.();
                    }}
                    key={dropdownitem.url}
                  >
                    {dropdownitem.title}
                  </a>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          ) : (
            <NavItem item={item} lang={lang} key={item.url}/>
          )
        );
      })}
    </>
  );
};
 
NavItems.propTypes = {
  items: PropTypes.array.isRequired, // Array di oggetti, puoi specificare ulteriormente se conosci la struttura
  lang: PropTypes.string.isRequired, // Stringa per la lingua
  mobile: PropTypes.bool, // Booleano per mobile
  closeNavigation: PropTypes.func, // Funzione per chiudere la navigazione
};

export default NavItems;